import React, { useEffect, useState } from "react";
import {
  getCourseListAPI,
  getRequest,
} from "../../../api/laravel/public/api";
import Course from "./Course/Course";
import Style from "./courselit.module.scss";
import { Start } from "@mui/icons-material";
import { Link, useLocation, useHistory } from "react-router-dom";
import "./course.css";

function CourseLit(props) {
  // const { data,data_r } = ;
  const [data, setData] = useState([]);
  const { section, user } = props;

  useEffect(() => {
    getCourseList();
  }, []);

  const getCourseList = async () => {
    const { data_r } = await getRequest("/course/list");
    setData(data_r);
  };

  return (
    <section id="mc-section-3" className="mc-section-3 section">
      <div className="container">
        <div className="feature-course">
          <div className="my-4">
            <h4 className="title-box text-uppercase">{section?.header}</h4>
           
              <Link to="/courses" className="all-course mc-btn btn-style-1">View all</Link>
          </div>
          <div className="row">
            {data?.map((items, index) => (
              <Link key={index} to={"/course/" + items?.uuid} className={`col-xs-12 col-sm-6 col-md-3`}>
                <div className="mc-item mc-item-2">
                  <div className="image-heading">
                    <img src={
                      items.poster.storage === "local"
                        ? process.env.REACT_APP_LOCAL_FILE_PATH +
                        items.poster.path +
                        "/medium/" +
                        items.poster.name
                        : items.poster.path
                    } alt="" />
                  </div>
                  <div className="meta-categories"><a>{items?.course_section?.length} Sections</a></div>
                  <div className="content-item">
                    <div className="image-author">
                      {/* <img src="images/avatar-1.jpg" alt="" /> */}
                    </div>
                    <h4>{items.title}</h4>
                    <div className="name-author">
                      By <a href="#">{items?.created_by?.first_name}</a>
                    </div>
                  </div>
                  <div className="ft-item">
                    <div className="rating">
                      <a href="#" className="active" />
                      <a href="#" className="active" />
                      <a href="#" className="active" />
                      <a href="#" className="active" />
                      <a href="#" />
                    </div>
                    <div className="view-info">
                      {/* <i className="icon md-users" />
                      2568 */}
                    </div>
                    <div className="comment-info">
                      {/* <i className="icon md-comment" />
                      25 */}
                    </div>
                    <div className="price">

                      <span className="price-old"> {items.amount == 0 ? "Free" : items.amount}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}


          </div>
        </div>

      </div>
    </section>
  );
}

export default CourseLit;
